module.exports = __webpack_public_path__ + "static/expenses-dashboard-d6e1fca0e56e691a5cd23cd85cf1feca.png";